// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mediumMaxWidth":"1199px","smallMaxWidth":"991px","extraSmallMaxWidth":"767px","mobileThreshold":"575px","container":"_3FoQuc3rboBpdQu8NByJqk","containerWithoutImage":"_3Quzi5KbN0rKUc6RaXiEim","titleContainer":"_39ofbkxeRZHFpPcrZtY_bE _2ELtkcMpIJZ1yyH_kfj3I7","title":"_1qiJ-VHKAMIsVoMK7WZXmX"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-index/category-banner/CategoryBanner.css
// module id = 1049
// module chunks = 1